import { render, staticRenderFns } from "./EditTypeManage.vue?vue&type=template&id=dd713454&"
import script from "./EditTypeManage.vue?vue&type=script&lang=js&"
export * from "./EditTypeManage.vue?vue&type=script&lang=js&"
import style0 from "./EditTypeManage.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports